module.exports = "<div class=\"text-center\">\n    <h2>An error occured</h2>\n</div>";